// Raw Table Overview, reached from the Brands module's Configuration Overview
// screen (operations/brands/.../raw_table_overview). RawTableOverview lives
// under the Brands module folder and is shared with the legacy
// BrandConfigurationReport module's own screen/route
// (RawTableOverviewScreen.tsx, operations/brand_configuration_report/...),
// which is untouched.
import RawTableOverview from "../../../../components/Partners/DataIntegrations/Brands/BrandConfigurationOverview/RawTableOverview/RawTableOverview";

const RawTableOverviewScreen = () => {
  return (
    <>
      <RawTableOverview />
    </>
  );
};

export default RawTableOverviewScreen;
